var render, staticRenderFns
import script from "./Parser.vue?vue&type=script&lang=js"
export * from "./Parser.vue?vue&type=script&lang=js"
import style0 from "./Parser.vue?vue&type=style&index=0&id=53588b50&prod&lang=css"
import style1 from "./Parser.vue?vue&type=style&index=1&id=53588b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53588b50",
  null
  
)

export default component.exports